// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2UcSp","upload":"Small_upload__27xbE","imageWrap":"Small_imageWrap__3sikq","removeBtn":"Small_removeBtn__2X_VF"};